export function maxLengthFromMinLength(minLength) {
    return Math.min(2 * minLength + 10, 0x7fffffff);
}
